require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-jacob-knaack.json") })
        }
      }, "path---blog-author-jacob-knaack");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-jacob-knaack!./.cache/json/blog-author-jacob-knaack.json
// module id = 649
// module chunks = 231608221292675